import { useSettingsRHF } from "../hooks/useSettingsRHF";
import { realEstateAssetsSchema } from "../types/settingsSchemas";
import type { RealEstateAssetsSettingsData } from "../types/settings";

/**
 * Essential fields shown during onboarding and always visible in settings.
 * Core property values and high-level other asset categories.
 */
export const REAL_ESTATE_ESSENTIAL_FIELDS: (keyof RealEstateAssetsSettingsData)[] =
  [
    "primaryResidence",
    "investmentProperties",
    "otherAssets",
    "depreciatingAssets",
  ];

/**
 * Advanced fields shown only in full settings via "Show more" toggle.
 * Specialized property types, business interests, and insurance.
 */
export const REAL_ESTATE_ADVANCED_FIELDS: (keyof RealEstateAssetsSettingsData)[] =
  [
    "vacationProperty",
    "landOtherRealEstate",
    "businessValue",
    "shareholderLoansReceivable",
    "insuranceCashValue",
  ];

/** All real estate & other assets fields */
export const ALL_REAL_ESTATE_FIELDS: (keyof RealEstateAssetsSettingsData)[] = [
  ...REAL_ESTATE_ESSENTIAL_FIELDS,
  ...REAL_ESTATE_ADVANCED_FIELDS,
];

/**
 * Shared logic for Real Estate & Other Assets form
 *
 * Handles form state, auto-save, and total calculation.
 */
export function useRealEstateAssetsLogic() {
  const { total: totalRealEstateAssets, ...rest } =
    useSettingsRHF<RealEstateAssetsSettingsData>(
      "realEstateAssets",
      realEstateAssetsSchema,
      ALL_REAL_ESTATE_FIELDS
    );

  return { ...rest, totalRealEstateAssets };
}
